const MESSAGE = {
  unauthenticated: "Unauthenticated user access",
  layoutChoiceWarning: `Once you've chosen a layout and started an inspection, changing the
            layout again will cause your data to be replaced`,
  layoutUpdating: `Converting layout.  Do not close modal.`,
  layoutUpdateSuccess: `Layout converted successfully.`,
  layoutUpdateFail: `Layout failed to convert. Continuing is ill-advised.`,
  layoutCheckMessage: `Checking compatibility`,
  loadingSections: `Fetching sections...`,
  loadingInspections: `Fetching inspections...`,
  loadingComments: `Loading section...`,
  layoutCompatible: `Checking for compatibility...`,
  generatingReport: `Your report might take awhile to be generated.  Do not close modal.`,
  layoutCreation: `Generating layout from template`,
  inspectionNotFound: `Inspection does not exsist`,
  inspectionSearch: `Searching for inspection...`,
  compressionError: `Something went wrong when trying to compress image`,
  nextworkEnabled: `You are now connected to the network.`,
  nextworkDisabled: `The network connection has been lost.`,
  layoutIncompatible: `This inspection uses an older layout file. Selecting a layout 
  template will convert it to the latest version.  A problem-free conversion is not guaranteed.`,
  copySection: `Copying a section will copy all items and their comments. Depending on
          the section size this may take awhile. Please wait until this notice
          closes after clicking accept in order to continue.`,
}
export default MESSAGE
